import React from "react";
import PaginaRecursos from "./PaginaRecursos";
import Seleccionarvehicle, { idVehicle } from "./Seleccionarvehicle";
import Detallsvehicle from "./Detallsvehicle";

const CONFIG = {
  titol: "Vehicles",
  subtitol: "Parc de vehicles: dades, manteniment (ITV i revisions) i assegurança.",
  icona: "🚐",
  textNou: "Nou vehicle",
  pestanyaAjuda: "vehicles",
  idDe: idVehicle,
  Llista: Seleccionarvehicle,
  Fitxa: Detallsvehicle,
};

function Vehicles() {
  return <PaginaRecursos config={CONFIG} />;
}

export default Vehicles;
